var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('basic-users-table',{attrs:{"canDelete":true,"canCreate":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }